import script from "./OpenApiSchemaViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenApiSchemaViewer.vue?vue&type=script&lang=ts&setup=true"

import "./OpenApiSchemaViewer.vue?vue&type=style&index=0&id=36d2b73a&lang=scss"

const __exports__ = script;

export default __exports__